module.exports = __webpack_public_path__ + "static/img/003.44f64a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/003.png
// module id = /c9B
// module chunks = 0